{
  "title": "Bàn làm việc",
  "today": {
    "heading": "Hôm nay",
    "empty": "Hôm nay không có buổi",
    "emptyRoster": "Buổi này chưa có học viên"
  },
  "badge": {
    "pending": "Chưa điểm danh",
    "done": "Đã điểm danh",
    "empty": "Không có HV",
    "locked": "Đã chốt sổ"
  },
  "day": {
    "backToToday": "Về hôm nay",
    "status": "{{count}} buổi · {{state}}",
    "statusDone": "đã điểm danh đủ",
    "statusPending": "còn {{n}} buổi chưa điểm danh",
    "statusNone": "chưa có buổi nào",
    "banner": "Bạn đang xem {{day}}, sửa điểm danh ngày cũ được, hoá đơn tháng sau sẽ tự bù trừ theo.",
    "emptyTitle": "Không có buổi nào ngày này",
    "emptyBody": "Chọn ngày khác trên dải tuần, hoặc thêm buổi đột xuất nếu có học bù.",
    "noSlotTitle": "Lịch trống",
    "noSlotBody": "Tạo lớp ở trang Lớp học, buổi học và điểm danh sẽ tự sinh ra.",
    "noSlotCta": "Tạo khung giờ"
  },
  "card": {
    "sessionDetail": "Chi tiết suất"
  },
  "week": {
    "thisWeek": "Tuần này",
    "prev": "Tuần trước",
    "next": "Tuần sau",
    "legend": {
      "done": "Đã điểm danh",
      "pending": "Chưa điểm danh",
      "future": "Sắp tới"
    },
    "pickDay": "Chọn ngày",
    "viewMonth": "Xem cả tháng →"
  },
  "gettingStarted": {
    "title": "Bắt đầu với LopHoc",
    "progress": "{{done}}/{{total}}",
    "progressLabel": "Đã xong {{done}} trên {{total}} bước",
    "menuLabel": "Tuỳ chọn thẻ Bắt đầu",
    "dismiss": "Ẩn",
    "next": "bước tiếp theo",
    "steps": {
      "subject": {
        "title": "Tạo môn học",
        "desc": "Môn học quyết định giá mỗi buổi / mỗi tháng."
      },
      "slot": {
        "title": "Tạo khung giờ cố định",
        "desc": "Buổi học và điểm danh tự sinh ra từ đây."
      },
      "student": {
        "title": "Thêm học viên",
        "desc": "Tên và người trả phí, chưa cần gì thêm."
      },
      "enrolled": {
        "title": "Thêm đăng ký học",
        "desc": "Gắn em với môn và cách đóng tiền, từ đây mới có học phí.",
        "hint": "Mở một học viên → Thêm đăng ký"
      },
      "placed": {
        "title": "Xếp lớp",
        "desc": "Xếp em vào khung giờ; từ đó có buổi để điểm danh.",
        "hint": "Mở một học viên → Xếp lớp"
      },
      "attendance": {
        "title": "Điểm danh buổi đầu tiên",
        "desc": "Điểm danh là nguồn của hoá đơn."
      }
    },
    "footerBefore": "Cuối tháng: ",
    "footerTerm": "Chốt sổ",
    "footerAfter": " tạo hoá đơn từ điểm danh, ở mục Chốt sổ & Hoá đơn."
  },
  "attention": {
    "title": "Cần chú ý",
    "countLabel": "{{count}} mục cần chú ý",
    "chot": {
      "pending": {
        "title": "Chốt sổ tháng {{month}}",
        "desc": "Còn {{count}} buổi tháng {{prev}} chưa điểm danh, điểm danh xong rồi chốt để bù trừ đúng"
      },
      "owed": {
        "title": "Tháng {{owed}} chưa chốt xong",
        "desc": "Chốt tháng đó trước rồi hãy chốt tháng {{month}}, nếu không sẽ không bao giờ được bù trừ"
      },
      "ready": {
        "title": "Chốt sổ tháng {{month}}",
        "desc": "Điểm danh đã đủ, chốt để gửi hoá đơn cho phụ huynh"
      },
      "action": "Chốt sổ"
    },
    "termOut": {
      "title": "{{student}} đã dùng hết khoá",
      "desc": "Thu học phí ngay để buổi tới không dạy chịu"
    },
    "termNearlyOut": {
      "title": "{{student}} sắp hết khoá",
      "desc": "Còn {{count}} buổi, nhắc phụ huynh đóng học phí trước khi hết buổi"
    },
    "term": {
      "action": "Xem học viên"
    },
    "termMore": {
      "title": "và {{count}} học viên khác",
      "action": "Xem danh sách"
    },
    "unmatched": {
      "title": "{{count}} giao dịch chưa khớp · {{total}}",
      "desc": "Tiền đã về tài khoản nhưng chưa gán được vào hoá đơn nào",
      "action": "Đối soát"
    },
    "reconcileExhausted": {
      "title": "Hết lượt tự khớp chuyển khoản tháng này",
      "desc": "Tiền vẫn về tài khoản của bạn, nhưng phải đánh dấu đã thanh toán bằng tay. Tự mở lại đầu tháng sau.",
      "action": "Xem gói"
    },
    "monthlyReview": {
      "action": "Viết nhận xét"
    }
  },
  "loadError": "Không thể tải buổi học hôm nay",
  "oneOff": {
    "link": "Thêm buổi đột xuất / học bù cho ngày này",
    "title": "Thêm buổi đột xuất / học bù",
    "forDay": "Buổi sẽ được thêm vào {{day}}",
    "subject": "Môn học",
    "pickSubject": "Chọn môn học",
    "students": "Học viên",
    "pickStudents": "Chọn học viên",
    "selectedCount": "{{n}} học viên",
    "removeStudent": "Bỏ chọn",
    "whatIsAria": "Buổi đột xuất là gì?",
    "whatIsTitle": "Buổi đột xuất",
    "whatIs1": "được thêm riêng cho ngày này, không nằm trong Thời khoá biểu và không lặp lại tuần sau. Dùng cho học bù hoặc dạy thêm.",
    "whatIs2": "Buổi này vẫn điểm danh như bình thường; học viên đóng theo buổi sẽ được tính vào kỳ chốt sổ tới.",
    "whatIs3": "Nếu đã có buổi cùng môn vào đúng giờ đó, học viên được ghép vào buổi đó thay vì tạo buổi mới.",
    "noEnrollments": "Chưa có học viên nào đang học"
  }
}
